import React, { useState, useEffect } from 'react';
import './Nav.css';

function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`nav${scrolled ? ' scrolled' : ''}`} id="nav">
      <div className="inner">
        <a href="#top" className="nav-logo">ATIBA</a>
        <ul className="nav-links">
          <li><a href="#books">Books</a></li>
          <li><a href="#excerpt">Excerpts</a></li>
          <li><a href="#reviews">Reviews</a></li>
          <li><a href="#about">About</a></li>
          {/* <li><a href="#blog">Blog</a></li> */}
        </ul>
      </div>
    </nav>
  );
}

export default Nav;
